<div id="page-wrap">
    <div class="inner-page-wrap">
        <!--    <ngx-spinner></ngx-spinner>-->
        <app-navbar></app-navbar>
        <iframe src="https://shuffll.co/privacy/"></iframe>
    </div>
</div>
